import PropTypes from 'prop-types'
import React from 'react'
import { reduxForm, Field } from 'redux-form'
import { FormattedMessage } from 'react-intl'
import {
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Button,
  ButtonGroup
} from 'react-bootstrap'

const onInputFocus = (event) => {
  const tempValue = event.target.value
  event.target.value = ''
  event.target.value = tempValue
}


export class EditDocumentSourceForm extends React.Component {
  static propTypes = {
    submitting: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
  }

  renderNameField = (field) => {
    return (
      <FormGroup
        validationState={field.meta.touched && field.meta.error ? 'error' : null}
      >
        <ControlLabel><FormattedMessage id='NAME' /></ControlLabel>
        <FormControl
          {...field.input}
          name={null}
          type='text'
          onFocus={onInputFocus}
        />
        {field.meta.touched && field.meta.error && <HelpBlock>{field.meta.error}</HelpBlock>}
      </FormGroup>
    )
  }

  render = () => {
    const {
      submitting,
      handleSubmit,
      onCancel
    } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <Field
          name='name'
          component={this.renderNameField}
        />
        <ButtonGroup>
          <Button type='submit' bsStyle='primary' disabled={submitting}><FormattedMessage id='SAVE' /></Button>
          <Button onClick={onCancel}><FormattedMessage id='CANCEL' /></Button>
        </ButtonGroup>
      </form>
    )
  }
}

export default reduxForm({
  form: 'editDocumentSourceForm'
})(EditDocumentSourceForm)
